import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsPagelessCustomizeTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_PAGELESS_CUSTOMIZE;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_REPORTS_PAGELESS_CUSTOMIZE;

	get id(): string {
		return TourId.REPORTS__PAGELESS_CUSTOMIZE;
	}

	override get keyForPersistantDone(): string {
		return ReportsPagelessCustomizeTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				allowStacked: false,
				attachTo: () => {
					return $('.pageless-actions-container');
				},
				scrollToAttachTo: true,
			},
		];
	}

	override start(): void {
		super.start();
		// don't mark done immediately - wait for user action
	}

	override onExplicitClose(): void {
		// User manually closed - mark all pageless tours as done
		this.flowTourReportsPagelessService.endAllTours();
		super.onExplicitClose();
	}
}
